/* eslint-disable prefer-const */
// import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
// import { TreeSelect } from 'antd';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
//  import ToastSwal from '@components/Shared/Alert/ToastSwal';
// import useGetConsolidationSet from '@hooks/Finance/ConsolidationSet/useGetConsolidationSet';
// import useGetCostCenters from '@hooks/Finance/ChartAccountsDetails/useGetCostCenters';
// import useGetCompanies from '@hooks/Finance/ChartAccountsDetails/useGetCompanies';
// import useGetBranches from '@hooks/Finance/ChartAccountsDetails/useGetBranches';
// import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';

// interface Props {
//   onAccountSelect: (account: any) => void;
//   accountDetails: any;
//   organizationId: string;
// }

// const CodeCombination = ({ onAccountSelect, accountDetails, organizationId }: Props) => {
//   const { t, i18n } = useTranslation();
//   const {
//     GlCompanyId: Gl_company_id,
//     GetGlBrancheId,
//     loading: loading2,
//     error: error2,
//   } = useGetConsolidationSet();

//   const { TreeCostCenters, findAccountNumberById } = useGetCostCenters();
//   const { OptionsCompanies } = useGetCompanies();
//   const { OptionsBranches } = useGetBranches();
//   const { OptionsAccounts, loading, error } = useGetAccounts();

//   const GlCompany = OptionsCompanies?.filter((f) => f.value === Gl_company_id);
//   const GlBranch = OptionsBranches?.filter((f) => f.value === GetGlBrancheId(organizationId));

//   const [selectedAccounts, setSelectedAccounts] = useState({
//     company: {
//       id: accountDetails?.companyId ?? null,
//       accountNumber:
//         OptionsCompanies?.find((f) => f.value === accountDetails?.companyId)?.accountNumber ?? '',
//     },
//     branch: {
//       id: accountDetails?.branchId ?? null,
//       accountNumber:
//         OptionsBranches?.find((f) => f.value === accountDetails?.branchId)?.accountNumber ?? '',
//     },

//     costCenter: {
//       id: accountDetails?.costCenterId ?? null,
//       accountNumber: findAccountNumberById(accountDetails?.costCenterId) ?? '',
//     },

//     account: {
//       id: accountDetails?.accountId ?? null,
//       accountNumber:
//         OptionsAccounts?.find((f) => f.value === accountDetails?.accountId)?.accountNumber ?? '',
//     },
//   });

//   useEffect(() => {
//     // تحديث بيانات الشركة
//     const company = GlCompany[0];
//     if (company?.value && !selectedAccounts.company.id) {
//       setSelectedAccounts((prevState) => ({
//         ...prevState,
//         company: {
//           id: company.value ?? null,
//           accountNumber: company.accountNumber ?? '',
//         },
//       }));
//     }

//     // تحديث بيانات الفرع
//     const branch = GlBranch[0];
//     if (branch?.value && !selectedAccounts.branch.id) {
//       setSelectedAccounts((prevState) => ({
//         ...prevState,
//         branch: {
//           id: branch.value ?? null,
//           accountNumber: branch.accountNumber ?? '',
//         },
//       }));
//     }
//   }, [GlBranch, GlCompany, selectedAccounts.branch.id, selectedAccounts.company.id]);

//   const handleChange = (name: string, option: any) => {
//     if (name === 'costCenter') {
//       var accountNumber = findAccountNumberById(option);
//       setSelectedAccounts((prevValues) => ({
//         ...prevValues,
//         [name]: { id: option, accountNumber: accountNumber },
//       }));
//     } else {
//       setSelectedAccounts((prevValues) => ({
//         ...prevValues,
//         [name]: { id: option?.value || null, accountNumber: option?.accountNumber || '' },
//       }));
//     }
//   };

//   const ChooseAccount = () => {
//     const { company, branch, costCenter, account } = selectedAccounts;

//     if (!company.id || !branch.id || !costCenter.id || !account.id) {
//       ToastSwal({
//         title: i18n.language === 'ar' ? 'يرجى إدخال جميع الحقول' : 'Please fill out all fields',
//         position: 'top-start',
//       });

//       return;
//     }

//     onAccountSelect(selectedAccounts); // Send the selected account back to parent
//   };

//   return (
//     <Loading loading={loading || loading2} error={error || error2} Type="Dots">
//       <div className="row">
//         <div className="col-lg-12  mb-4">
//           <div className="input-group flex-nowrap ">
//             <span
//               className="input-group-text  d-flex justify-content-center"
//               style={{ width: '140px' }}>
//               {t('Company')}
//             </span>
//             {/* {GlCompany?.length > 0 && ( */}
//             <Select
//               isDisabled
//               classNamePrefix="react-select"
//               className=" w-100"
//               isLoading={loading}
//               isSearchable={true}
//               options={GlCompany}
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               onChange={(option) => handleChange('company', option)}
//               value={GlCompany?.find((f) => f.value === selectedAccounts.company.id)}
//               // defaultValue={GlCompany[0]}
//             />
//             {/* // )} */}
//           </div>
//         </div>

//         <div className="col-lg-12 mb-4 ">
//           <div className="input-group flex-nowrap">
//             <span
//               className="input-group-text  d-flex justify-content-center"
//               style={{ width: '140px' }}>
//               {t('Branch')}
//             </span>
//             <Select
//               isDisabled
//               classNamePrefix="react-select"
//               className=" w-100"
//               isLoading={loading}
//               isSearchable={true}
//               isClearable
//               // options={OptionsBranches?.filter(
//               //   (f) => f.accountParant === selectedAccounts.company.id
//               // )}
//               options={GlBranch?.filter((f) => f.accountParant === selectedAccounts.company.id)}
//               name="branchId"
//               // placeholder='إختر'
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               onChange={(option) => handleChange('branch', option)}
//               value={OptionsBranches?.find((f) => f.value === selectedAccounts.branch.id)}
//             />
//           </div>
//         </div>

//         <div className="col-lg-12 mb-4 ">
//           <div className="input-group flex-nowrap">
//             <span
//               className="input-group-text  d-flex justify-content-center"
//               style={{ width: '140px' }}>
//               {t('CostCenter')}
//             </span>
//             <TreeSelect
//               showSearch
//               treeData={TreeCostCenters}
//               style={{ borderRadius: '1px !important' }}
//               className="custom-tree-select w-100  rounded-0"
//               treeLine
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               allowClear
//               treeDefaultExpandAll
//               getPopupContainer={(triggerNode) => triggerNode.parentNode}
//               onChange={(option) => handleChange('costCenter', option)}
//               value={selectedAccounts.costCenter.id}
//             />
//           </div>
//         </div>

//         <div className="col-lg-12 mb-4 ">
//           <div className="input-group flex-nowrap">
//             <span
//               className="input-group-text  d-flex justify-content-center"
//               style={{ width: '140px' }}>
//               {t('Accounts')}
//             </span>
//             <Select
//               classNamePrefix="react-select"
//               className=" w-100"
//               isLoading={loading}
//               isSearchable={true}
//               isClearable
//               name="accountId"
//               options={OptionsAccounts}
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               onChange={(option) => handleChange('account', option)}
//               value={OptionsAccounts?.find((f) => f.value === selectedAccounts.account.id)}
//             />
//           </div>
//         </div>
//       </div>

//       <div className="text-center text-end">
//         <button type="button" className="btn btn-theme w-25" onClick={() => ChooseAccount()}>
//           {t('إختيــــار')}
//         </button>
//       </div>
//     </Loading>
//   );
// };

// export default CodeCombination;

import { useEffect, useState, useMemo } from 'react';
import Select from 'react-select';
import { TreeSelect } from 'antd';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import ToastSwal from '@components/Shared/Alert/ToastSwal';
import useGetConsolidationSet from '@hooks/Finance/ConsolidationSet/useGetConsolidationSet';

import useGlChartLookups from '@hooks/Finance/ChartAccountsDetails/useGlChartLookups';

interface Props {
  onAccountSelect: (account: any) => void;
  accountDetails: any;
  organizationId: string;
}

const CodeCombination = ({ onAccountSelect, accountDetails, organizationId }: Props) => {
  const { t, i18n } = useTranslation();
  const { GlCompanyId: Gl_company_id, GetGlBrancheId, loading: loading2, error: error2 } = useGetConsolidationSet();

  const { TreeCostCenters, OptionsCompanies, OptionsBranches, OptionsAccounts, loading, error } = useGlChartLookups();

  function findAccountNumberById(id: any) {
    function search(data: any, id: any) {
      for (let item of data) {
        if (item.value === id) {
          return item.accountNumber;
        }
        if (item.children && item.children?.length > 0) {
          const result: any = search(item.children, id);
          if (result) {
            return result;
          }
        }
      }
      return null; // Return null if not found
    }

    return search(TreeCostCenters, id); // Use TreeCostCenters directly
  }

  const [accountSearch, setAccountSearch] = useState('');
  const [previewCombination, setPreviewCombination] = useState('');

  const GlCompany = OptionsCompanies?.filter(f => f.value === Gl_company_id);
  const GlBranch = OptionsBranches?.filter(f => f.value === GetGlBrancheId(organizationId));

  // تصفية الحسابات بناءً على البحث
  const filteredAccounts = useMemo(() => {
    if (!accountSearch) return OptionsAccounts;

    return OptionsAccounts?.filter(
      account =>
        account.label?.toLowerCase().includes(accountSearch.toLowerCase()) ||
        account.accountNumber?.includes(accountSearch)
    );
  }, [OptionsAccounts, accountSearch]);

  const [selectedAccounts, setSelectedAccounts] = useState({
    company: {
      id: accountDetails?.companyId ?? null,
      accountNumber: OptionsCompanies?.find(f => f.value === accountDetails?.companyId)?.accountNumber ?? ''
    },
    branch: {
      id: accountDetails?.branchId ?? null,
      accountNumber: OptionsBranches?.find(f => f.value === accountDetails?.branchId)?.accountNumber ?? ''
    },

    costCenter: {
      id: accountDetails?.costCenterId ?? null,
      accountNumber: findAccountNumberById(accountDetails?.costCenterId) ?? ''
    },

    account: {
      id: accountDetails?.accountId ?? null,
      accountNumber: OptionsAccounts?.find(f => f.value === accountDetails?.accountId)?.accountNumber ?? ''
    }
  });

  useEffect(() => {
    // تحديث بيانات الشركة
    const company = GlCompany[0];
    if (company?.value && !selectedAccounts.company.id) {
      setSelectedAccounts(prevState => ({
        ...prevState,
        company: {
          id: company.value ?? null,
          accountNumber: company.accountNumber ?? ''
        }
      }));
    }

    // تحديث بيانات الفرع
    const branch = GlBranch[0];
    if (branch?.value && !selectedAccounts.branch.id) {
      setSelectedAccounts(prevState => ({
        ...prevState,
        branch: {
          id: branch.value ?? null,
          accountNumber: branch.accountNumber ?? ''
        }
      }));
    }
  }, [GlBranch, GlCompany, selectedAccounts.branch.id, selectedAccounts.company.id]);

  // تحديث معاينة التركيبة المحاسبية
  useEffect(() => {
    const combination = [
      selectedAccounts.company.accountNumber,
      selectedAccounts.branch.accountNumber,
      selectedAccounts.account.accountNumber,
      selectedAccounts.costCenter.accountNumber
    ]
      .filter(Boolean)
      .join('-');

    setPreviewCombination(combination);
  }, [selectedAccounts]);

  const handleChange = (name: string, option: any) => {
    if (name === 'costCenter') {
      const accountNumber = findAccountNumberById(option);
      setSelectedAccounts(prevValues => ({
        ...prevValues,
        [name]: { id: option, accountNumber: accountNumber }
      }));
    } else {
      setSelectedAccounts(prevValues => ({
        ...prevValues,
        [name]: { id: option?.value || null, accountNumber: option?.accountNumber || '' }
      }));
    }
  };

  const ChooseAccount = () => {
    const { company, branch, costCenter, account } = selectedAccounts;

    if (!company.id || !branch.id || !costCenter.id || !account.id) {
      ToastSwal({
        title: i18n.language === 'ar' ? 'يرجى إدخال جميع الحقول' : 'Please fill out all fields',
        position: 'top-start'
      });

      return;
    }

    onAccountSelect(selectedAccounts); // Send the selected account back to parent
  };

  return (
    <div className='p-3'>
      <Loading loading={loading || loading2} error={error || error2} Type='Dots'>
        <div className='row '>
          {/* معاينة التركيبة المحاسبية */}
          {previewCombination && (
            <div className='col-12 mb-3'>
              <div className='alert alert-info py-2'>
                <div className='d-flex justify-content-between align-items-center'>
                  <strong>{t('AccountCombinationPreview')}:</strong>
                  <code className='fs-6'>{previewCombination}</code>
                </div>
              </div>
            </div>
          )}

          <div className='col-lg-12  mb-4'>
            <div className='input-group flex-nowrap '>
              <span className='input-group-text  d-flex justify-content-center' style={{ width: '140px' }}>
                {t('Company')}
              </span>
              <Select
                isDisabled
                classNamePrefix='react-select'
                className=' w-100'
                isLoading={loading}
                isSearchable={true}
                options={GlCompany}
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                onChange={option => handleChange('company', option)}
                value={GlCompany?.find(f => f.value === selectedAccounts.company.id)}
              />
            </div>
          </div>

          <div className='col-lg-12 mb-4 '>
            <div className='input-group flex-nowrap'>
              <span className='input-group-text  d-flex justify-content-center' style={{ width: '140px' }}>
                {t('Branch')}
              </span>
              <Select
                isDisabled
                classNamePrefix='react-select'
                className=' w-100'
                isLoading={loading}
                isSearchable={true}
                isClearable
                options={GlBranch?.filter(f => f.accountParant === selectedAccounts.company.id)}
                name='branchId'
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                onChange={option => handleChange('branch', option)}
                value={OptionsBranches?.find(f => f.value === selectedAccounts.branch.id)}
              />
            </div>
          </div>

          <div className='col-lg-12 mb-4 '>
            <div className='input-group flex-nowrap'>
              <span className='input-group-text  d-flex justify-content-center' style={{ width: '140px' }}>
                {t('CostCenter')}
              </span>
              <TreeSelect
                showSearch
                treeData={TreeCostCenters}
                style={{ borderRadius: '1px !important' }}
                className='custom-tree-select w-100  rounded-0'
                treeLine
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                allowClear
                treeDefaultExpandAll
                getPopupContainer={triggerNode => triggerNode.parentNode}
                onChange={option => handleChange('costCenter', option)}
                value={selectedAccounts.costCenter.id}
              />
            </div>
          </div>

          <div className='col-lg-12 mb-4 '>
            <div className='input-group flex-nowrap'>
              <span className='input-group-text  d-flex justify-content-center' style={{ width: '140px' }}>
                {t('Accounts')}
              </span>
              <Select
                classNamePrefix='react-select'
                className=' w-100'
                isLoading={loading}
                isSearchable={true}
                isClearable
                name='accountId'
                options={filteredAccounts}
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                onChange={option => handleChange('account', option)}
                value={OptionsAccounts?.find(f => f.value === selectedAccounts.account.id)}
                onInputChange={value => setAccountSearch(value)}
              />
              {accountSearch && (
                <div className='text-muted small mt-1'>
                  {t('Found')} {filteredAccounts?.length || 0} {t('results')}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className='text-center text-end'>
          <button type='button' className='btn btn-theme w-25' onClick={() => ChooseAccount()}>
            {t('إختيــــار')}
          </button>
        </div>
      </Loading>
    </div>
  );
};

export default CodeCombination;
